module.exports = __webpack_public_path__ + "static/media/send-backward.c3bc470a.svg";